import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => ({
  dropzone: {
    textAlign: 'center',
    height: '90%',
    background: '#ffffff',
    border: '2px dashed #eee',
    margin: '1rem',
    padding: '1rem',
    boxSizing: 'border-box',
    marginBottom: '5px'
  },
  dropzoneErrored: {
    border: '2px dashed #FF0C3E'
  },
  btnStyle: {
    left: '8px',
    'border-radius': '5px'
  },
  uploadicon: {
    fontSize: '4.5rem',
    color: '#eee'
  },
  dropzonetext: {
    color: '#ada8a8',
    fontSize: '16px'
  },
  fileinput: {
    display: 'none'
  },
  btnUpload: {
    padding: '3px 15px 3px 2px'
  },
  uploadNotes: {
    color: 'gray',
    fontSize: '10px',
    fontStyle: 'italic',
    marginTop: '12px'
  },
  uploadterms: {
    fontSize: '15px'
  },
  dropZoneDisabled: {
    opacity: '30%',
    pointerEvents: 'none'
  }
}))
